export default __webpack_public_path__ + "static/media/faveicon.6d2d3c0a.jpg";